import React, { useState } from "react";
import API_BASE_URL from "../apiConfig";

export default function InvoiceReport() {
  const [invoiceNo, setInvoiceNo] = useState("50");
  const [d, setD] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    setError("");
    const res = await fetch(`${API_BASE_URL}/reports/invoice?invoiceNo=${invoiceNo}`);
    if (res.ok) setD(await res.json());
    else { setD(null); setError("Invoice not found."); }
  };

  const handlePrint = () => window.print();

  return (
    <div className="invoice-a4-wrapper">
      <style>{`
        /* ---------- Screen controls (hidden on print) ---------- */
        .invoice-a4-wrapper {
          background: #e5e7eb;
          min-height: 100vh;
          padding: 24px 0;
          font-family: Arial, Helvetica, sans-serif;
        }
        .invoice-controls {
          max-width: 210mm;
          margin: 0 auto 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
        }
        .invoice-controls input {
          padding: 8px 10px;
          border: 1px solid #cbd5e1;
          border-radius: 6px;
          font-size: 14px;
        }
        .invoice-controls button {
          padding: 8px 16px;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
          background: #2563eb;
          color: white;
        }
        .invoice-controls button.print-btn {
          background: #16a34a;
        }
        .invoice-error {
          text-align: center;
          color: #dc2626;
          margin-bottom: 12px;
        }

        /* ---------- A4 page ---------- */
        .invoice-page {
          width: 210mm;
          min-height: 297mm;
          margin: 0 auto;
          background: white;
          box-shadow: 0 0 8px rgba(0,0,0,0.2);
          box-sizing: border-box;
          padding: 15mm 12mm;
          display: flex;
          flex-direction: column;
        }
        .invoice-body { flex: 1 0 auto; }

        .invoice-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 2px solid #111827;
          padding-bottom: 10px;
          margin-bottom: 14px;
        }
        .invoice-company h1 {
          font-size: 20px;
          margin: 0 0 4px 0;
          color: #111827;
        }
        .invoice-company p {
          font-size: 11px;
          margin: 0;
          color: #4b5563;
        }
        .invoice-title {
          text-align: right;
        }
        .invoice-title h2 {
          font-size: 18px;
          margin: 0 0 4px 0;
          color: #111827;
          letter-spacing: 1px;
        }
        .invoice-title p {
          font-size: 11px;
          margin: 0;
          color: #4b5563;
        }

        .invoice-meta-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin-bottom: 16px;
          font-size: 12px;
        }
        .invoice-meta-box {
          border: 1px solid #d1d5db;
          border-radius: 4px;
          padding: 8px 10px;
        }
        .invoice-meta-box strong {
          display: block;
          font-size: 10px;
          text-transform: uppercase;
          color: #6b7280;
          margin-bottom: 4px;
          letter-spacing: 0.5px;
        }

        table.invoice-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
          margin-bottom: 16px;
        }
        table.invoice-table th,
        table.invoice-table td {
          border: 1px solid #d1d5db;
          padding: 7px 9px;
        }
        table.invoice-table th {
          background: #f3f4f6;
          text-align: left;
          font-size: 11px;
          text-transform: uppercase;
          color: #374151;
        }
        table.invoice-table td.num {
          text-align: right;
        }
        table.invoice-table tr.total-row td {
          font-weight: bold;
          background: #f9fafb;
          font-size: 13px;
        }

        .invoice-remarks {
          font-size: 11px;
          color: #4b5563;
          margin-bottom: 24px;
        }

        .invoice-footer {
          margin-top: auto;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          border-top: 1px solid #d1d5db;
          padding-top: 12px;
        }
        .invoice-footer .signature-box {
          text-align: center;
          font-size: 11px;
          color: #4b5563;
        }
        .invoice-footer .signature-line {
          width: 160px;
          border-top: 1px solid #9ca3af;
          margin-top: 40px;
          padding-top: 4px;
        }
        .invoice-footer .footer-note {
          font-size: 10px;
          color: #9ca3af;
          text-align: center;
        }

        /* ---------- Print rules ---------- */
        @media print {
          @page {
            size: A4;
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            background: white;
          }
          .invoice-a4-wrapper {
            background: white;
            padding: 0;
            min-height: 0;
          }
          .invoice-controls {
            display: none;
          }
          .invoice-page {
            width: 210mm;
            min-height: 297mm;
            box-shadow: none;
            margin: 0;
            page-break-after: always;
          }
        }
      `}</style>

      <div className="invoice-controls">
        <input
          placeholder="Invoice No."
          value={invoiceNo}
          onChange={(e) => setInvoiceNo(e.target.value)}
        />
        <button onClick={load}>Load Invoice</button>
        {d && (
          <button className="print-btn" onClick={handlePrint}>
            Print A4
          </button>
        )}
      </div>

      {error && <p className="invoice-error">{error}</p>}

      {d && (
        <div className="invoice-page">
          <div className="invoice-body">
            <div className="invoice-header">
              <div className="invoice-company">
                <h1>ExpressLogistics</h1>
                <p>Courier &amp; Logistics Services</p>
                <p>Registered Office Address, City, State - PIN</p>
                <p>GSTIN: XXXXXXXXXXXXXXX</p>
              </div>
              <div className="invoice-title">
                <h2>TAX INVOICE</h2>
                <p>Invoice No: {d.invoiceNo}</p>
                <p>Date: {d.txnDate?.slice(0, 10)}</p>
              </div>
            </div>

            <div className="invoice-meta-grid">
              <div className="invoice-meta-box">
                <strong>Billed To</strong>
                {d.partyName}
                <br />
                {[d.address, d.city].filter(Boolean).join(", ")}
                <br />
                GSTIN: {d.gstin ?? "-"}
              </div>
              <div className="invoice-meta-box">
                <strong>Invoice Details</strong>
                Invoice No: {d.invoiceNo}
                <br />
                Date: {d.txnDate?.slice(0, 10)}
              </div>
            </div>

            <table className="invoice-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th className="num">Qty</th>
                  <th className="num">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Taxable Amount</td>
                  <td className="num">{d.totalQty.toFixed(2)}</td>
                  <td className="num">{d.taxableAmount.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Charges / Tax</td>
                  <td className="num">-</td>
                  <td className="num">{d.totalCharges.toFixed(2)}</td>
                </tr>
                <tr className="total-row">
                  <td colSpan={2}>Net Amount</td>
                  <td className="num">{d.grandTotal.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>

            {d.remarks && (
              <p className="invoice-remarks">
                <strong>Remarks:</strong> {d.remarks}
              </p>
            )}
          </div>

          <div className="invoice-footer">
            <div className="signature-box">
              <div className="signature-line">Receiver's Signature</div>
            </div>
            <div className="signature-box">
              <div className="signature-line">Authorised Signatory</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}